/**
 * Multi-word AND search.
 * Splits the search term on whitespace and requires EVERY word to appear
 * somewhere in the target string (case-insensitive, any order).
 *
 * Examples:
 *   matchesSearch('PIPE MS A CLASS 100MM', 'pipe 100mm') → true
 *   matchesSearch('PIPE MS A CLASS 150MM', 'pipe 100mm') → false
 *   matchesSearch('AHU 10000CFM',          'ahu 10000')  → true
 */
export const matchesSearch = (target, searchTerm) => {
  if (!searchTerm || !searchTerm.trim()) return true;
  const words = searchTerm.toLowerCase().trim().split(/\s+/);
  const t = target.toLowerCase();
  return words.every((w) => t.includes(w));
};

/**
 * Sort a filtered array so that items whose name STARTS WITH the first
 * typed word come before items that merely contain it.
 * Within each group results are sorted alphabetically.
 */
export const sortByRelevance = (items, searchTerm, getName = (x) => x.name) => {
  if (!searchTerm || !searchTerm.trim()) return items;
  const firstWord = searchTerm.toLowerCase().trim().split(/\s+/)[0];
  return [...items].sort((a, b) => {
    const aLow = getName(a).toLowerCase();
    const bLow = getName(b).toLowerCase();
    const aStarts = aLow.startsWith(firstWord);
    const bStarts = bLow.startsWith(firstWord);
    if (aStarts && !bStarts) return -1;
    if (!aStarts && bStarts) return  1;
    return aLow.localeCompare(bLow);
  });
};
